import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTotals } from '../helpers';
import TotalItem from './components/TotalItem';
import classes from './TotalSection.module.scss';
import { useWindowSize } from '../../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../../utils/constants';
import colors from '../../../../scss/colors';

function VerticalDevider() {
  return (
    <div style={{ width: '0', height: '100%', border: '1.5px solid #F6F7F9' }} className={classes.onlyForDesktop} />
  );
}

export default function TotalSection({ data, workTypes, rateType }) {
  const { t } = useTranslation();
  const size = useWindowSize();

  const totals = getTotals(data);
  const isMobile = size.width < responsiveSizeTimesheet;

  // Mobile version - completely new layout
  if (isMobile) {
    return (
      <section className={classes.mobileContainer}>
        <div className={classes.mobileTotalHeader}>
          <span className={classes.totalLabel}>{t('dashboard.timesheet.total.total_time')}</span>
          <span className={classes.totalValue}>{totals['Total Time']}</span>
        </div>

        <div className={classes.mobileGrid}>
          <div className={classes.mobileItem}>
            <span className={classes.itemLabel}>{t('dashboard.timesheet.total.standard_time')}</span>
            <span className={classes.itemValue}>{totals[workTypes?.find((x) => x.key === 1)?.label]}</span>
          </div>

          <div className={classes.mobileItem}>
            <span className={classes.itemLabel}>{t('dashboard.timesheet.total.over_time')}</span>
            <span className={classes.itemValue}>{totals[workTypes?.find((x) => x.key === 2)?.label]}</span>
          </div>
        </div>
      </section>
    );
  }

  // Desktop version - EXACT ORIGINAL CODE
  return (
    <section className={`${classes.container} flex flex-row w-full justify-between`}>
      {size.width < responsiveSizeTimesheet && (
        <p className={classes.totalLabel}>{t('dashboard.timesheet.total.total_time')}</p>
      )}
      <div className="flex gap-4">
        <TotalItem
          item={t('dashboard.timesheet.total.standard_time')}
          value={totals[workTypes?.find((x) => x.key === 1)?.label]}
          rateType={rateType}
        />
        <VerticalDevider className={classes.onlyForDesktop} />
        <TotalItem
          item={t('dashboard.timesheet.total.over_time')}
          value={totals[workTypes?.find((x) => x.key === 2)?.label]}
          rateType={rateType}
        />
        <VerticalDevider className={classes.onlyForDesktop} />
        {size.width > responsiveSizeTimesheet && (
          <TotalItem
            item={t('dashboard.timesheet.total.pto')}
            value={totals[workTypes?.find((x) => x.key === 5)?.label]}
            rateType={rateType}
          />
        )}
        <VerticalDevider className={classes.onlyForDesktop} />
      </div>
      <div className='flex'>
        <TotalItem
          item={t('dashboard.timesheet.total.total_time')}
          value={totals['Total Time']}
          rateType={rateType}
          sx={{
            backgroundColor: colors.LIGHTER_GREY,
            padding: '6px 28px',
            borderRadius: '35px'
          }}
        />
      </div>
    </section>
  );
}